/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FavoriteDto } from '../../models/favorite-dto';

export interface FavoriteControllerFindMyFavorites$Params {
}

export function favoriteControllerFindMyFavorites(http: HttpClient, rootUrl: string, params?: FavoriteControllerFindMyFavorites$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FavoriteDto>>> {
  const rb = new RequestBuilder(rootUrl, favoriteControllerFindMyFavorites.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FavoriteDto>>;
    })
  );
}

favoriteControllerFindMyFavorites.PATH = '/api/favorite';
